(function () {
  var STORAGE_KEY = 'ca_recently_viewed';

  function readList() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 12)));
  }

  function formatMoney(cents, format) {
    var amount = (Number(cents) / 100).toFixed(2);
    var withThousands = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var match = String(format || 'Rs. {{amount}}').match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value = key.indexOf('no_decimals') !== -1 ? String(Math.round(Number(cents) / 100)) : withThousands;
    return String(format || 'Rs. {{amount}}').replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function offerLabel(price, compare) {
    var selling = Number(price);
    var original = Number(compare);
    if (!original || original <= selling) return '';
    return Math.round(((original - selling) / original) * 100) + '% off';
  }

  function imageSrc(image) {
    if (!image) return '';
    var src = typeof image === 'string' ? image : image.src;
    if (!src) return '';
    return src.indexOf('//') === 0 ? 'https:' + src : src;
  }

  function colorIndex(product) {
    return (product.options || []).findIndex(function (option) {
      var name = String(typeof option === 'string' ? option : option.name || '').toLowerCase();
      return name === 'color' || name === 'colour';
    });
  }

  function buildCard(product, root) {
    var variants = product.variants || [];
    var selected = variants.find(function (variant) { return variant.available; }) || variants[0];
    var href = product.url || '/products/' + product.handle;
    var wrapper = document.createElement('div');
    wrapper.className = 'product-card-wrapper';
    var card = document.createElement('div');
    card.className = 'hala-card';

    var media = document.createElement('div');
    media.className = 'hala-card__media-container';
    var link = document.createElement('a');
    link.className = 'hala-card__media-link';
    link.href = href;
    var img = document.createElement('img');
    img.className = 'hala-card__image';
    img.alt = product.title || '';
    img.src = imageSrc(selected && selected.featured_image) || imageSrc(product.featured_image);
    link.appendChild(img);
    media.appendChild(link);
    var offerText = offerLabel(selected ? selected.price : product.price, selected ? selected.compare_at_price : 0);
    if (offerText) {
      var badges = document.createElement('div');
      badges.className = 'hala-card__badges';
      var badge = document.createElement('span');
      badge.className = 'hala-card__badge hala-card__badge--sale';
      badge.textContent = offerText;
      badges.appendChild(badge);
      media.appendChild(badges);
    }
    card.appendChild(media);

    var info = document.createElement('div');
    info.className = 'hala-card__info';
    var content = document.createElement('div');
    content.className = 'hala-card__info-content';

    var title = document.createElement('h3');
    title.className = 'hala-card__title';
    var titleLink = document.createElement('a');
    titleLink.href = href;
    titleLink.textContent = product.title || '';
    title.appendChild(titleLink);
    content.appendChild(title);

    var swatches = document.createElement('div');
    swatches.className = 'hala-card__swatches';
    var optionIndex = colorIndex(product);
    if (optionIndex > -1) {
      var key = 'option' + (optionIndex + 1);
      var values = [];
      variants.forEach(function (variant) {
        if (variant[key] && variant[key] !== 'Default Title' && values.indexOf(variant[key]) === -1) values.push(variant[key]);
      });
      values.slice(0, 5).forEach(function (value) {
        var variant = variants.find(function (entry) { return entry[key] === value; });
        if (!variant) return;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'hala-card__swatch';
        var thumbSrc = imageSrc(variant.featured_image);
        if (thumbSrc) {
          var thumb = document.createElement('img');
          thumb.src = thumbSrc;
          thumb.alt = value;
          thumb.width = 35;
          thumb.height = 35;
          button.appendChild(thumb);
        }
        button.addEventListener('click', function () {
          img.src = thumbSrc || img.src;
          var input = card.querySelector('[name="id"]');
          if (input) input.value = variant.id;
        });
        swatches.appendChild(button);
      });
    }
    content.appendChild(swatches);

    var price = document.createElement('div');
    price.className = 'hala-card__price-wrap';
    if (selected && selected.compare_at_price > selected.price) {
      var compare = document.createElement('s');
      compare.className = 'hala-card__price-compare';
      compare.textContent = formatMoney(selected.compare_at_price, root.dataset.moneyFormat);
      price.appendChild(compare);
    }
    var current = document.createElement('span');
    current.className = 'hala-card__price-current';
    current.textContent = formatMoney(selected ? selected.price : product.price, root.dataset.moneyFormat);
    price.appendChild(current);
    if (offerText) {
      var offer = document.createElement('span');
      offer.className = 'hala-card__offer';
      offer.textContent = offerText;
      price.appendChild(offer);
    }
    content.appendChild(price);

    var formWrap = document.createElement('product-form');
    formWrap.className = 'hala-card__cart';
    formWrap.setAttribute('data-hide-errors', 'true');
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = selected ? selected.id : '';
    var button = document.createElement('button');
    button.type = 'submit';
    button.className = 'hala-card__atc';
    button.innerHTML = '<span>' + (root.dataset.addLabel || 'Add to cart') + '</span>';
    form.appendChild(input);
    form.appendChild(button);
    formWrap.appendChild(form);
    content.appendChild(formWrap);

    info.appendChild(content);
    card.appendChild(info);
    wrapper.appendChild(card);
    return wrapper;
  }

  function init(root) {
    var currentHandle = root.dataset.currentHandle;
    var limit = Number(root.dataset.limit) || 4;
    var previous = readList().filter(function (item) {
      return item && item.handle && item.handle !== currentHandle;
    }).slice(0, limit);

    if (currentHandle) {
      var next = [{ id: root.dataset.currentId, handle: currentHandle }].concat(
        readList().filter(function (item) { return item.handle !== currentHandle; })
      );
      writeList(next);
    }

    if (!previous.length) return;

    Promise.all(previous.map(function (item) {
      return fetch('/products/' + encodeURIComponent(item.handle) + '?view=card')
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (html) {
          if (!html) return null;
          return new DOMParser().parseFromString(html, 'text/html').querySelector('product-component');
        })
        .catch(function () { return null; });
    })).then(function (cards) {
      var grid = root.querySelector('[data-previously-seen-grid]');
      cards.filter(Boolean).forEach(function (card) {
        grid.appendChild(card);
      });
      if (grid.children.length) root.hidden = false;
    });
  }

  document.querySelectorAll('[data-previously-seen]').forEach(init);
})();
